import React, {useContext, useRef} from 'react';
import propTypes from 'prop-types';
import { useGSAP } from '@gsap/react';
import Context from '../OriginStoryProvider';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const Teaser = ({title}) => {
	const { data: {content} } = useContext(Context);

	const teaserContainer = useRef(null);

	useGSAP(() => {
		if (!content.chapters) return;
		
		const tl = gsap.timeline()
			.from('.teaser__title', {
				opacity: 0,
			})
			.from('.teaser__icon', {
				opacity: 0,
			})

		ScrollTrigger.create({
			trigger: teaserContainer.current,
			start: 'bottom bottom',
			pin: true,
			scrub: 2,
			animation: tl
		});
	}, {scope: teaserContainer.current, dependencies: [content.chapters]});

	if (!content.chapters) return null;

	return (
		<div className='teaser main-grid' ref={teaserContainer}>
			<div className='main-grid__margin'></div>
			<div className='main-grid__body'>
				<p className='teaser__title'>{title}</p>
				<svg className='teaser__icon' width="20" height="41" viewBox="0 0 20 41" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g id="Layer_1" clipPath="url(#clip0_141_49)">
						<path id="Vector" d="M10.0115 41C8.84429 38.4302 7.43137 36.0649 5.77393 33.904C4.11649 31.7431 2.19146 29.7629 0.00115272 27.9657C1.78777 27.9799 3.45675 28.2854 5.00692 28.8797C6.55594 29.474 7.98731 30.35 9.29873 31.5089L9.29873 26.7069C9.29873 22.592 8.6609 19.5919 7.38524 17.7056C6.10957 15.8192 4.02999 14.7566 1.14763 14.5189L1.14763 -8.24063e-07C3.29527 0.208006 5.08997 0.858177 6.53172 1.94932C7.97232 3.04166 9.1338 4.64153 10.0127 6.75132C10.8916 4.62727 12.0519 3.01551 13.4937 1.91604C14.9343 0.816577 16.722 0.178292 18.8547 -5.00639e-08L18.8547 14.5189C15.9712 14.7566 13.8927 15.8181 12.6171 17.7056C11.3414 19.5919 10.7036 22.5931 10.7036 26.7069L10.7036 31.5089C12.03 30.35 13.4637 29.474 15.0058 28.8797C16.5479 28.2854 18.2134 27.9811 20 27.9657C17.7947 29.7783 15.8662 31.7609 14.2157 33.9147C12.5652 36.0684 11.1638 38.4302 10.0104 41L10.0115 41Z" fill="#AF1E27"/>
					</g>
				</svg>
			</div>
			<div className='main-grid__margin'></div>
		</div>
	)
}

export default Teaser;

Teaser.propTypes = {
	title: propTypes.string,
}